import { getErrorDetailsFromGraphQLError } from 'activate-errors';

type TranslateFn = (key: string) => string;

export function getDeleteCostOffsetCodeErrorMessage(
  error: unknown,
  t: TranslateFn
): string {
  const defaultMessage = t('abp.productsServices.deleteCostOffsetCode.error');

  const [firstDetail] = getErrorDetailsFromGraphQLError(error);

  if (firstDetail?.message) {
    return firstDetail.message;
  }

  if (error && typeof error === 'object' && 'graphQLErrors' in error) {
    const { graphQLErrors } = error;

    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) {
      const serverMessage = graphQLErrors
        .map((e: { message?: string }) => e.message)
        .find(Boolean);

      return serverMessage || defaultMessage;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return defaultMessage;
}
